/**
 * User store.
 *
 * @author Artem Bakulin <dekkyartem@gmail.com>
 */

import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { User } from '@/types/admin';
import { getNow } from '@/utils/date';

export enum RoleEnum {
    ROLE_ADMIN = 'ROLE_ADMINISTRATOR',
    ROLE_SUPER_ADMIN = 'ROLE_SUPER_ADMIN',
    ROLE_DOCTOR = 'ROLE_DOCTOR',
}

export const ADMIN_ROLES = [RoleEnum.ROLE_ADMIN, RoleEnum.ROLE_SUPER_ADMIN];
export const EVERYONE = [RoleEnum.ROLE_DOCTOR, RoleEnum.ROLE_ADMIN, RoleEnum.ROLE_SUPER_ADMIN]

export const MODULE_NAME = 'user';

@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class UserModule extends VuexModule {
    id: number | null = null;
    login: string | null = null;
    phone: string | null = null;
    role: RoleEnum | null = null;
    roleTitle = '';
    doctorId = 0; // if user is a doctor, store the doctorId
    consultationId: number | null = null;
    
    isAuthenticated = false;
    token: string | null = null;

    get isDoctor()  {
        return this.role === RoleEnum.ROLE_DOCTOR;
    }

    get isAdmin()   {
        return this.role && ADMIN_ROLES.includes(this.role);
    }

    @Mutation
    setToken(token: string|null) {
        this.token = token;
        if (typeof window.localStorage === 'object') {
            if (token) {
                localStorage.setItem('tokenAdmin', token);
            } else {
                localStorage.removeItem('tokenAdmin');
            }
        }
    }

    @Mutation
    setAuthenticated(isAuthenticated: boolean) {
        this.isAuthenticated = isAuthenticated;
    }

    @Mutation
    setUser(user: User) {
        this.id = user.id;
        this.login = user.login;
        this.phone = user.phone;
        this.role = user.roles.length ? user.roles[0] : null;
        this.roleTitle = user.roleTitle;
    }

    @Mutation
    clearUser() {
        this.id = null;
        this.login = null;
        this.phone = null;
        this.role = null;
        this.roleTitle = '';
        this.isAuthenticated = false;
    }

    @Mutation
    setDoctorId(id: number) {
        this.doctorId = id;
    }
    
    @Mutation
    SET_CONSULTATION_ID(id: number) {
        this.consultationId = id;
    }

    @Action
    generateConsultationId() {
        const id = `${Math.floor(Math.random() * 100)}${getNow()}`.substring(0, 5);
        this.SET_CONSULTATION_ID(+id);
    }

    @Action
    removeToken() {
        this.setAuthenticated(false);
        this.setToken(null);
    }
}

export default getModule(UserModule);
